/**
 * Define options used to create a render target texture
 */
var RenderTargetCreationOptions = /** @class */ (function () {
    function RenderTargetCreationOptions() {
    }
    return RenderTargetCreationOptions;
}());
export { RenderTargetCreationOptions };
//# sourceMappingURL=renderTargetCreationOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Materials/Textures/renderTargetCreationOptions.js
// module id = gUwW
// module chunks = 0